import React, { useState } from 'react';

import { Field, Message, RadioGroup, TextOutput } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';

const NestedCSSTest: React.FC = () => {
  const [option, setOption] = useState(1);

  return (
    <>
      <Message severity="info">This page is for testing the performance of nested css grids/sections.</Message>
      <PageSection heading="Test List Field Sections">
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            label="Used to re-render the page"
            value={option}
            onChange={(event: any) => setOption(event.data.value)}
            options={[
              { label: 'Option 1', value: 1 },
              { label: 'Option 2', value: 2 },
            ]}
          />
        </ListFieldSection>
        <ListFieldSection wide>
          <ListFieldSection wide>
            <ListFieldSection wide>
              <ListFieldSection wide>
                <ListFieldSection wide>
                  <ListFieldSection wide>
                    <ListFieldSection wide>
                      <ListFieldSection wide heading="Nested List Field Sections">
                        <Field input={<TextOutput />} label="Option Value" value={option} />
                      </ListFieldSection>
                    </ListFieldSection>
                  </ListFieldSection>
                </ListFieldSection>
              </ListFieldSection>
            </ListFieldSection>
          </ListFieldSection>
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default NestedCSSTest;
